import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginMtfHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import { marginScrollService } from "../../../../service/marginFiles/marginScrollService";

export interface IMarginMtfTableMobProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginMtfTableMob: React.FC<IMarginMtfTableMobProps> = props => {
	const scrollBodyRef = React.useRef<HTMLUListElement>(null);
	const fixedBodyRef = React.useRef<HTMLUListElement>(null);
	const scrollHeadRef = React.useRef<HTMLUListElement>(null);

	return (
		<div className="mrgn_mtf_tbl margin_table_mob">
			<div className="fixed_col">
				<ul className="hdr_row">
					<li className="tr">
						<div className="td">
							<span className="sort_cont Name">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="Name"
									onSort={props.sortProps.onSort}
									colName={marginMtfHeading.name}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={fixedBodyRef}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="Name ib" dangerouslySetInnerHTML={{ __html: row.Name }}></span>
							</div>
						</li>
					))}
				</ul>
			</div>

			<div className="scrolling_cont">
				<ul className="hdr_row" ref={scrollHeadRef}>
					<li className="tr">
						<div className="td">
							<span className="sort_cont NSESymbol">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="NSESymbol"
									onSort={props.sortProps.onSort}
									colName={marginMtfHeading.nseSymbol}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont BSECode">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="BSECode"
									onSort={props.sortProps.onSort}
									colName={marginMtfHeading.bseCode}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont ISIN">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="ISIN"
									onSort={props.sortProps.onSort}
									colName={marginMtfHeading.isin}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont Haircut">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="Haircut"
									onSort={props.sortProps.onSort}
									colName={marginMtfHeading.Haircut}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={scrollBodyRef} onScroll={() => marginScrollService(scrollBodyRef, fixedBodyRef, scrollHeadRef)}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="NSESymbol ib">{row.NSESymbol}</span>
							</div>
							<div className="td">
								<span className="BSECode ib">{row.BSECode}</span>
							</div>
							<div className="td">
								<span className="ISIN ib">{row.ISIN}</span>
							</div>
							<div className="td">
								<span className="Haircut ib">{toINR(row.Haircut)}</span>
							</div>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default MarginMtfTableMob;
